import { IUser } from "services/types";
import { useMeQuery } from "queries";
import { useIsAuth } from "hooks/useIsAuth";

interface CurrentUserObject extends IUser {
}

class CurrentUserObject {
  readonly CONTENT_MANAGER_ROLE = "content manager";

  constructor(src: IUser) {
    Object.assign(this, src, {});
  }

  getRoles(): string[] {
    return this.roles ?? [];
  }

  hasRole(role: string): boolean {
    if (!this.roles) {
      return false;
    }

    return this.roles.indexOf(role) >= 0;
  }

  isContentManager(): boolean {
    return this.hasRole(this.CONTENT_MANAGER_ROLE);
  }
}

export const useVisitorInfo = (): CurrentUserObject|null => {
  const isAuth = useIsAuth();
  const { isSuccess, data } = useMeQuery();

  if (!isAuth || !isSuccess) {
    return null;
  }

  if (data) {
    return new CurrentUserObject(data);
  } else {
    return null;
  }
};
